export default __webpack_public_path__ + "static/media/sportBadge.6435059c.png";